export enum ManagePartners {
  additionalConsent = 'additionalConsent',
  vendorConsents = 'vendorConsents',
  vendorLegitimateInterests = 'vendorLegitimateInterests'
}